export const icon = (name: string) => ({
  name: name,
  options: {
    icon: name,
    stylingMode: "text",
  },
  location: "after",
});

export const icons = (names: string[]) => names.map((name) => icon(name));
